export enum COLORS {
  SAY_COBALT = "#1968FF",
  BLACK = "#000000",
  ICE_BLUE = "#F0F8FF",
  PERIWINKLE = "#ACC8FF",
  TANGERINE = "#FFD80D",
  LIME = "#EBFF6A",
  LIGHT_GREY = "#EBEBEB",
  LIGHT_TANGERINE = "#FFF1A9",
  LIGHT_LIME = "#F5FFB9",
  SATURATED_GREY = "#8B8B8B",
  SATURATED_TANGERINE = "#FFC01D",
  SATURATED_LIME = "#CFED0D",
  SHADED_COBALT = "#002875",
  SHADED_GREY = "#282828",
  SHADED_TANGERINE = "#FFC01D",
  SHADED_LIME = "#B2CC0B",
  BRIGHT_YELLOW = "#F9FD1C",
  BRIGHT_ORANGE = "#FE9D0D",
  BRIGHT_RED = "#FF5050",
  BRIGHT_PINK = "#FD8AFF",
  BRIGHT_PURPLE = "#B67DFF",
  BRIGHT_BLUE = "#4BF4FF",
  BRIGHT_GREEN = "#6ACC48",
  MERCURY = "#E6E6E6",
  MUTED_YELLOW = "#FBF195",
  MUTED_ORANGE = "#FFAA7A",
  MUTED_RED = "#DD8585",
  MUTED_PINK = "#FFCEE3",
  MUTED_PURPLE = "#D7B9EF",
  MUTED_BLUE = "#7DC5ED",
  MUTED_GREEN = "#78C184",
  LIGHT_YELLOW = "#FFFBD4",
  LIGHT_ORANGE = "#FFE6D8",
  LIGHT_RED = "#FFE5E5",
  LIGHT_PINK = "#FFF0F6",
  LIGHT_PURPLE = "#F6EBFF",
  LIGHT_BLUE = "#E5FFFD",
  LIGHT_GREEN = "#EFFFEA",
  SATURATED_YELLOW = "#F4DD00",
  SATURATED_ORANGE = "#E2720A",
  SATURATED_RED = "#C70000",
  SATURATED_PINK = "#B52AB8",
  SATURATED_PURPLE = "#6D06BD",
  SATURATED_BLUE = "#119CAF",
  SATURATED_GREEN = "#227406",
  SHADED_YELLOW = "#9F9000",
  SHADED_ORANGE = "#8B4E2C",
  SHADED_RED = "#7B0000",
  SHADED_PINK = "#642B65",
  SHADED_PURPLE = "#380462",
  SHADED_BLUE = "#095560",
  SHADED_GREEN = "#123D03",
  WHITE = "#ffffff",
  P_HIGH_EMPHASIS = "#000000",
  P_MED_HIGH_EMPHASIS = "rgba(0,0,0,0.87)",
  P_MED_EMPHASIS = "rgba(0,0,0,0.74)",
  P_MED_LOW_EMPHASIS = "rgba(0,0,0,0.6)",
  P_DISABLED = "rgba(0,0,0,0.38)",
  S_HIGH_EMPHASIS = "#FFFFFF",
  S_MED_EMPHASIS = "rgba(255,255,255,0.60)",
  S_DISABLED = "rgba(255,255,255,0.38)",
  SAY_DISABLED = "rgba(25, 104, 255, 0.38)",
  S_OUTLINE = "rgba(255,255,255,0.12)",
  P_OUTLINE = "rgba(0,0,0,0.12)",
}
